const karaoke = [
    {
        lang: 'fr',
        endScreenimage: 'endScreen',
    },
    {
        lang: 'en',
        endScreenimage: 'endScreen-en',
    },
    {
        lang: 'it',
        endScreenimage: 'endScreen-it',
    },
    {
        lang: 'pol',
        endScreenimage: 'endScreen-pol',
    },
    {
        lang: 'de',
        endScreenimage: 'endScreen-de',
    },
    {
        lang: 'es',
        endScreenimage: 'endScreen-es',
    },
];

export default karaoke;
